export default __webpack_public_path__ + "static/media/legal.e05ae1c4.md";